// extracted by mini-css-extract-plugin
export default {"cls1":"renderResults-Skeleton_cls1__GUrUG","cls2":"renderResults-Skeleton_cls2__qESSB renderResults-Skeleton_cls1__GUrUG","secondary":"renderResults-Skeleton_secondary__PH866"};